import clsx from 'clsx';
import React from 'react';
import styled from './inputPasscode.module.css';

type TPasscodeDot = {
    currentLength: number;
    dotIndex: number;
};
const PasscodeDot = ({ dotIndex, currentLength }: TPasscodeDot) => {
    return <div className={clsx(styled.dot, currentLength >= dotIndex && styled.selected)} />;
};
export default PasscodeDot;
